import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"600\",\"700\",\"800\"],\"variable\":\"--font-sora\"}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/legal/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DpaInfoBanner","default"] */ "/app/src/components/legal/dpa-gate-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VersionBanner"] */ "/app/src/components/version-banner.tsx");
